<template>
  <v-container>

    <!-- Diálogo de Carregamento -->
    <v-dialog v-model="loading" persistent max-width="300px">
      <v-card>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
          <div>Aguarde, carregando dados...</div>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-card>
      <v-card-title>Vincular Aparelho à Máquina</v-card-title>
      <v-divider></v-divider>

      <v-card-text class="dialog-content">
        <v-row>
          <v-col v-if="!data" cols="12" sm="8" md="8"> <!-- Columna para el campo de entrada -->
            <v-text-field label="ID da máquina" v-model="id_maquina" :disabled="maquinaBuscada" outlined
              dense></v-text-field>
            <v-btn @click="fetchBuscarMaquina" :disabled="loading || !id_maquina" color="primary" class="mt-2 mt-sm-4"
              block>
              Buscar Máquina
            </v-btn>
          </v-col>




          <div v-if="data && data.id"> <!-- Verifica se 'data' e 'data.id_maquina' existem -->

            <!-- Tornar o conteúdo rolável -->
            <div class="dialog-content">

              <v-container>

                <!-- Descrição Máquina -->

                <div class="info-row mt-3">
                  <div class="info-item">
                    <div class="info-title gradient-title">Máquina</div>
                    <div class="info-value mb-3" style="font-weight: bold; font-size: 1.2em;">
                      {{ formatId(data.id) }} - {{ data.descricao_maquina }}
                    </div>

                  </div>

                </div>
                <v-row>



                  <!-- Número de Série e Tipo Máquina -->
                  <v-col cols="6">
                    <div class="info-title gradient-title">Número de Série:</div>
                    <div class="info-value">
                      {{ data?.numero_serie || "Não Especificado" }}
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="info-title gradient-title">Tipo Máquina:</div>
                    <div class="info-value">
                      {{
                        data?.tipo_maquina?.tipo_maquinas || "Não Especificado"
                      }}
                    </div>
                  </v-col>

                  <!-- Setor e Sub Setor -->
                  <v-col cols="6">
                    <div class="info-title gradient-title">Setor:</div>
                    <div class="info-value">
                      {{ data.setor?.descricao_setor || "Não Especificado" }}
                    </div>
                  </v-col>


                  <!-- Fila e Posição -->
                  <v-col cols="6">
                    <div class="info-title gradient-title">Localização:</div>
                    <div class="info-value">F {{ data?.fila || "-" }} / P {{ data?.fila || "-" }} </div>
                  </v-col>




                  <!-- Marca e Modelo -->
                  <v-col cols="6">
                    <div class="info-title gradient-title">Marca:</div>
                    <div class="info-value">
                      {{ data?.marca || "Não Especificado" }}
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="info-title gradient-title">Modelo:</div>
                    <div class="info-value">
                      {{ data?.modelo || "Não Especificado" }}
                    </div>
                  </v-col>




                </v-row>


                <v-col v-if="data && data.id" cols="12">

                  <h3 class="mt-2 mb-2">Adicionar Aparelho</h3>
                  <v-text-field label="Digite o ID do aparelho" v-model="id_aparelho" outlined dense></v-text-field>
                  <v-btn @click="fetchAparelho" :disabled="loading || !id_aparelho" color="primary" class="mt-3">
                    Vincular Aparelho
                  </v-btn>




                  <v-dialog v-model="dialogAdicionarAparelho" persistent max-width="500px">
                    <v-card>
                      <!-- Título del diálogo -->
                      <v-card-title class="text-h6 font-weight-bold bg-primary white--text">
                        Atenção! Adicionar Aparelho
                      </v-card-title>

                      <!-- Divider para separar título del contenido -->
                      <v-divider></v-divider>

                      <!-- Contenido del diálogo -->
                      <v-card-text class="py-4">
                        <p class="mb-4"><strong>Descrição:</strong> {{ selectedAparelho?.descricao_aparelho }}</p>
                        <p class="mb-2 text-body-1 font-weight-regular">
                          Você deseja adicionar este aparelho?
                        </p>
                      </v-card-text>

                      <!-- Divider para separar contenido de las acciones -->
                      <v-divider></v-divider>

                      <!-- Botones de acción -->
                      <v-card-actions class="justify-end">
                        <v-btn text @click="closeModal" color="secondary">Cancelar</v-btn>
                        <v-btn @click="adicionarAparelho" color="primary" :loading="loading" class="ml-2" elevation="1">
                          Confirmar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <!-- Dialogo para confirma exclusao de aparelho -->
                  <v-dialog v-model="showDialoagExcluirAparelho" persistent max-width="500px">
                    <v-card>
                      <!-- Título del diálogo -->
                      <v-card-title class="text-h6 font-weight-bold bg-primary white--text">
                        Você deseja remover este aparelho?
                      </v-card-title>

                      <!-- Divider para separar título del contenido -->
                      <v-divider></v-divider>

                      <!-- Contenido del diálogo -->
                      <v-card-text class="py-4">
                        <p class="mb-4"><strong>id:</strong> {{ selectedAparelhoExcluir?.id }}</p>
                        <p class="mb-4"><strong>Descrição:</strong> {{ selectedAparelhoExcluir?.descricao_aparelho }}
                        </p>

                      </v-card-text>

                      <!-- Divider para separar contenido de las acciones -->
                      <v-divider></v-divider>

                      <!-- Botones de acción -->
                      <v-card-actions class="justify-end">
                        <v-btn text @click="fecharModalExcluirAparelho" color="secondary">Cancelar</v-btn>
                        <v-btn @click="deleteAparelho(selectedAparelhoExcluir.id)" color="primary" :loading="loading"
                          class="ml-2" elevation="1">
                          Remover
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>


                </v-col>

                <!-- Consultas De Aparelhos Aparelhos -->
                <v-col cols="12" v-if="data?.aparelhos && data.aparelhos.length">
                  <div class="info-title gradient-title">Aparelhos:</div>

                  <!-- Cabeçalho da Tabela -->
                  <div class="table-header">
                    <div class="table-cell">ID</div>
                    <div class="table-cell">Descrição</div>
                    <div class="table-cell">Ação</div>
                  </div>

                  <!-- Lista de Aparelhos -->
                  <div v-for="aparelho in data.aparelhos" :key="aparelho.id" class="table-row">
                    <div class="table-cell">{{ aparelho.id }}</div>
                    <div class="table-cell">{{ aparelho.tipo_aparelho.descricao_tipo_aparecelho }} </div>
                    <div class="table-cell">
                      <v-btn flat @click="RemoverAparelho(aparelho)" color="error">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-container>
            </div>

          </div>










          <!-- <v-col cols="12" v-if="data?.aparelhos?.length > 0">
          <div v-for="aparelho in data.aparelhos" :key="aparelho.id_aparelho" class="manutencao-card">
            <div class="card-content">
              <span>{{ aparelho.id_aparelho }} - {{ aparelho.descricao_aparelho }} - {{
                formatarData(aparelho.data_maquina) }}</span>
              <v-btn icon @click="removerAparelho(aparelho.id)" color="error">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col> -->


        </v-row>
      </v-card-text>

    </v-card>

    <!-- Área dos Botões -->
    <div class="buttons-container">
      <v-row justify="center">

        <v-btn color="secondary" class="mx-2" @click="voltarMenu">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { useToast } from "vue-toastification";
import { vincularAparelhosService } from "@/services/vincularAparelhosService";

export default {
  data() {
    return {
      id_maquina: "",
      id_aparelho: "",
      data: null,
      errorMessage: "",
      loading: false,
      selectedAparelho: null, // Armazena dados do aparelho selecionado
      dialogAdicionarAparelho: false, // Controla a visibilidade do diálogo
      showDialoagExcluirAparelho: false, // Controla a visibilidade do diálogo
      maquinaBuscada: false,
      selectedAparelhoExcluir: null,
    };
  },
  methods: {
    formatId(id) {
      return String(id).padStart(4, "0");
    },
    formatarData(dataCompleta) {
      if (!dataCompleta) return "";
      const data = new Date(dataCompleta);
      return `${String(data.getDate()).padStart(2, "0")}-${String(data.getMonth() + 1).padStart(2, "0")}-${data.getFullYear()}`;
    },
    clearError() {
      this.errorMessage = "";
      this.id_aparelho = "";
    },



    async fetchBuscarMaquina() {
      const toast = useToast();
      this.loading = true;
      this.errorMessage = "";
      this.data = null;

      const waitingToast = toast.info("Aguarde, buscando máquina...", { timeout: false, closeOnClick: false });

      try {

        // Processa o ID da máquina
        let idMaquina = this.id_maquina.trim();


        if (idMaquina.startsWith("MAQ") || idMaquina.startsWith("MAR")) {
          idMaquina = parseInt(idMaquina.replace(/\D/g, ''), 10);
        }



        const response = await vincularAparelhosService.buscarMaquinaId(idMaquina);
        toast.dismiss(waitingToast);

        if (response && response.id) {
          this.data = response;
          this.maquinaBuscada = true;
          toast.success("Máquina carregada com sucesso!");
        } else {
          this.errorMessage = "Máquina não encontrada.";
          this.id_maquina = "";
          toast.error(this.errorMessage);
        }
      } catch (error) {
        toast.dismiss(waitingToast);
        this.id_maquina = "";
        this.errorMessage = error.message || "Erro ao conectar com o servidor.";
        toast.error(this.errorMessage);
      }
      this.loading = false;
    },




    async AtualizarTela() {
      this.loading = true;
      try {
        const response = await vincularAparelhosService.buscarMaquinaId(this.id_maquina);

        if (response && response.id) {
          this.data = response;
          this.loading = false;
        } else {
          this.errorMessage = "Máquina não encontrada ou resposta inválida.";
          this.loading = false;
          toast.error(this.errorMessage);
        }
      } catch (error) {
        toast.dismiss(waitingToast);
        this.errorMessage = "Erro ao conectar com o servidor.";
        toast.error(this.errorMessage);
        this.loading = false;
      }
      this.loading = false;
    },

    voltarMenu() {
      this.$router.push({ name: "MenuDefault" }).catch(() => { });
    },
    async fetchAparelho() {
      const toast = useToast();
      this.loading = true;
      this.errorMessage = "";


      const isAlreadyLinked = this.data.aparelhos.some(
        (aparelho) => aparelho.id === parseInt(this.id_aparelho)
      );

      if (isAlreadyLinked) {
        // Mostrar mensagem de erro e cancelar o processo
        toast.error("Este aparelho já está vinculado à máquina.");
        this.dialogAdicionarAparelho = false;
        this.loading = false;
        return;
      }


      const waitingToast = toast.info("Aguarde, buscando aparelho...", { timeout: false, closeOnClick: false });

      try {

        // quero verificar se o aparelho ja existe na maquina
        // Verifique se o aparelho já está na lista de aparelhos da máquina


        const response = await vincularAparelhosService.buscarAparelhoId(this.id_aparelho);
        toast.dismiss(waitingToast);

        if (response && response.id) {
          this.selectedAparelho = response;
          this.dialogAdicionarAparelho = true;
          toast.success("Aparelho encontrado!");

        } else {
          this.errorMessage = "Aparelho não encontrado.";
          this.id_aparelho = "";

          toast.error(this.errorMessage);
        }
      } catch (error) {
        toast.dismiss(waitingToast);
        this.id_aparelho = "";

        this.errorMessage = error.message || "Erro ao conectar com o servidor.";
        toast.error(this.errorMessage);
      }
      this.loading = false;
    },

    async adicionarAparelho() {
      const toast = useToast();
      if (!this.selectedAparelho) return;

      this.loading = true;
      const waitingToast = toast.info("Aguarde, adicionando aparelho...", { timeout: false, closeOnClick: false });

      try {
        const response = await vincularAparelhosService.adicionarAparelho(this.id_maquina, this.id_aparelho);
        toast.dismiss(waitingToast);

        if (response && response.message === "Aparelho atualizado com sucesso.") {
          toast.success("Aparelho adicionado com sucesso!");
          this.selectedAparelho = null;
          this.dialogAdicionarAparelho = false;

          this.id_aparelho = "";
          await this.AtualizarTela();

          //this.fetchBuscarMaquina();
        } else {
          this.errorMessage = response.error_message || "Erro desconhecido ao adicionar aparelho.";
          toast.error(this.errorMessage);
        }
      } catch (error) {
        toast.dismiss(waitingToast);
        this.errorMessage = "Erro ao conectar com o servidor.";
        toast.error(this.errorMessage);
      }

      this.loading = false;
    },

    fecharModalExcluirAparelho() {
      this.showDialoagExcluirAparelho = false;
      this.selectedAparelhoExcluir = null;
    },
    RemoverAparelho(obj) {
      this.selectedAparelhoExcluir = obj;

      this.showDialoagExcluirAparelho = true;
    },

    async deleteAparelho(id_aparelho) {
      const toast = useToast();

      this.loading = true;
      const waitingToast = toast.info("Aguarde, removendo aparelho...", { timeout: false, closeOnClick: false });

      try {
        const response = await vincularAparelhosService.removerAparelho(id_aparelho);
        toast.dismiss(waitingToast);

        if (response.status === "success") {
          toast.success("Aparelho removido com sucesso!");

          await this.AtualizarTela();

          this.selectedAparelhoExcluir = null;
          this.showDialoagExcluirAparelho = false;
          this.loading = false;
        } else {

          this.errorMessage = response.error_message;
          toast.error(this.errorMessage);
        }
      } catch (error) {
        toast.dismiss(waitingToast);
        this.errorMessage = "Erro ao conectar com o servidor.";
        toast.error(this.errorMessage);
      }

      this.loading = false;
    },
    focusIdAparelho() {
      this.$nextTick(() => {
        const inputElement = document.getElementById('id_aparelho');
        if (inputElement) {
          inputElement.focus();
          inputElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    },



    closeModal() {
      this.id_aparelho = "";
      this.selectedAparelho = null;
      this.dialogAdicionarAparelho = false;
    },


  },
};
</script>

<style scoped>
.manutencao-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 8px;
}

.cards-container {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.card-title {
  font-size: 1rem;
  background: linear-gradient(to right, #2196f3, #2196f3);
  color: white;
  padding: 10px;
  border-radius: 4px;
}

.gradient-title {
  background: linear-gradient(to right, #f0f0f0, #e0e0e0);
  padding: 5px;
  border-radius: 4px;
  text-align: center;
  font-weight: bold;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: bold;
}

.info-item {
  flex: 1;
  margin-right: 10px;
  font-weight: bold;
}

.info-value {
  text-align: center;
  padding: 5px;
  border-bottom: 1px solid #ddd;
  font-weight: normal;
}

.dialog-content {
  max-height: 70vh;
  /* Altura máxima en telas grandes */
  overflow-y: auto;
  overflow-x: auto;
  transition: padding-bottom 0.3s ease;
  /* Adiciona uma transição suave */
}

/* Estilo para o container dos botões */
.buttons-container {
  padding: 16px;
  margin-top: 16px;
  background-color: white;
}


/* Ajustes para desktop e tablet - limita a largura e centraliza */
@media (min-width: 601px) {
  .v-dialog__content .v-card {
    max-width: 600px;
    /* Limita a largura para melhorar a visualização em telas maiores */
    margin: auto;
    /* Centraliza a caixa de diálogo */
  }

  .buttons-container {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}

/* Ajustes para dispositivos móveis */
@media (max-width: 600px) {
  .v-dialog__content .v-card {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    margin: 0;
    padding: 0;
  }

  .buttons-container {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }

  .dialog-content {
    max-height: calc(100vh - 50px);
    /* Ajusta a altura para compensar o teclado */
    padding-bottom: 0;
    /* Padding inicial para o ajuste */
  }
}

.table-header,
.table-row {
  display: flex;
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

.table-header {
  font-weight: bold;
  background-color: #f5f5f5;
}

.table-cell {
  flex: 1;
  text-align: left;
  padding: 4px 8px;
}

/* Ajusta a largura das colunas */
.table-cell:first-child {
  flex: 0.5;
}

.table-cell:nth-child(2) {
  flex: 2;
}

.table-cell:last-child {
  flex: 0.5;
  text-align: center;
}

/* Ajustes adicionais para o diálogo em dispositivos móveis */
@media (max-width: 600px) {
  .v-toolbar-title.text-h5 {
    font-size: 1.2rem;
  }
}
</style>
